import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const TableSkeleton = () => {
  return (
    <Box>
      <Table className={styles['table__skeleton']}>
        <Thead>
          <Tr>
            <Th className={styles['skeleton__head']} width="210px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="21px" width="60%" />
                <SkeletonComponent height="21px" width="21px" />
              </Flex>
            </Th>
            <Th width="210px" className={styles['skeleton__head']}>
              <Flex>
                <SkeletonComponent height="21px" width="50%" mb="2px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']}>
              <Flex justifyContent="space-between">
                <SkeletonComponent height="21px" width="60%" />
                <SkeletonComponent height="21px" width="21px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} width="150">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="21px" width="70%" />
                <SkeletonComponent height="21px" width="21px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} width="100">
              <Flex>
                <SkeletonComponent height="21px" width="70%" />
              </Flex>
            </Th>
            <Th width="194px" className={styles['skeleton__head']}>
              <Flex justifyContent="center">
                <SkeletonComponent height="21px" width="50%" />
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <Iteration
            items={[1, 2, 3, 4, 5, 6, 7, 8]}
            render={(num) => {
              return (
                <Tr key={num}>
                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="21px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="21px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="21px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="21px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="21px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <Flex gap="10px" justifyContent="center">
                      <SkeletonComponent height="42px" width="42px" borderRadius="16px" />
                      <SkeletonComponent height="42px" width="42px" borderRadius="8px" />
                    </Flex>
                  </Td>
                </Tr>
              );
            }}
          />
        </Tbody>
      </Table>
    </Box>
  );
};

export default TableSkeleton;
